import { Cookie } from './cookie.js';
import { hasCookieStorage, hasLocalStorage, hasSessionStorage, } from './detector.js';
export const preferredStorage = null;
export function getAvailableStorage() {
    if (preferredStorage) {
        return preferredStorage;
    }
    if (hasLocalStorage()) {
        return localStorage;
    }
    if (hasCookieStorage()) {
        return new CookieStorage();
    }
    if (hasSessionStorage()) {
        return sessionStorage;
    }
    return new NullStorage();
}
export class CookieStorage {
    static prefix = 'coveo_';
    getItem(key) {
        return Cookie.get(`${CookieStorage.prefix}${key}`);
    }
    removeItem(key) {
        Cookie.erase(`${CookieStorage.prefix}${key}`);
    }
    setItem(key, data, expire) {
        Cookie.set(`${CookieStorage.prefix}${key}`, data, expire);
    }
}
export class CookieAndLocalStorage {
    cookieStorage = new CookieStorage();
    getItem(key) {
        return localStorage.getItem(key) || this.cookieStorage.getItem(key);
    }
    removeItem(key) {
        this.cookieStorage.removeItem(key);
        localStorage.removeItem(key);
    }
    setItem(key, data) {
        localStorage.setItem(key, data);
        this.cookieStorage.setItem(key, data, 31556926000); // 1 year first party cookie
    }
}
export class NullStorage {
    getItem(_key) {
        return null;
    }
    removeItem(_key) {
        /**/
    }
    setItem(_key, _data) {
        /**/
    }
}
